export const CUSTOM_RESOURCE_LIMITS = "customResourceLimits";
